// uiStore.ts
import { create } from 'zustand'

type UIStore = {
  isDrawerOpen: boolean
  isProfileMenuOpen: boolean
  isAddPetModalOpen: boolean
  openDrawer: () => void
  closeDrawer: () => void
  toggleDrawer: () => void
  openProfileMenu: () => void
  closeProfileMenu: () => void
  toggleProfileMenu: () => void
  openAddPetModal: () => void
  closeAddPetModal: () => void
  disconnectionModalOpen?: boolean
  setDisconnectionModalOpen?: (open: boolean) => void
  setDisconnectionModalClose?: (open: boolean) => void
}

export const useUIStore = create<UIStore>((set) => ({
  isDrawerOpen: false,
  isProfileMenuOpen: false,
  isAddPetModalOpen: false,
  openDrawer: () => set({ isDrawerOpen: true }),
  closeDrawer: () => set({ isDrawerOpen: false }),
  toggleDrawer: () => set((state) => ({ isDrawerOpen: !state.isDrawerOpen })),
  openProfileMenu: () => set({ isProfileMenuOpen: true }),
  closeProfileMenu: () => set({ isProfileMenuOpen: false }),
  toggleProfileMenu: () => set((state) => ({ isProfileMenuOpen: !state.isProfileMenuOpen })),
  openAddPetModal: () => set({ isAddPetModalOpen: true }),
  closeAddPetModal: () => set({ isAddPetModalOpen: false }),
  disconnectionModalOpen: false,
  setDisconnectionModalOpen: () => set({ disconnectionModalOpen: true }),
  setDisconnectionModalClose: () => set({ disconnectionModalOpen: false }),
}))
